import { useLocation } from "react-router-dom";
import { CourseProgress } from "../../components/CourseProgress"
import { TitleBar } from "../../components/TitleBar"


export const ChildProgress = () => {
    const location = useLocation();
    const { id, name, courseName, courseId } = location.state || {};

    return (
        <>
            <div className="p-4 min-h-screen">
                <TitleBar
                    title={name}
                    subTitle={courseName}
                    isBackTo={true}
                    backPath="/parent/dashboard"
                    backState={{ from: "child-progress" }}
                    backToTitle="Back to Dashboard"
                />
                <div className="w-full py-8">
                    <CourseProgress courseId={courseId} userId={id} />
                </div>
            </div>
        </>
    )
}